<script>
import { defineComponent, computed, unref } from 'vue-demi'
import { dateFormat } from '@aixuexi/tol-utils'
import store from '@/store'
export default defineComponent({
  props: {
    itemData: {
      type: Object,
      default: () => ({
        groupName: '', // 小组名称
        studentNum: '', // 人数
        userName: '', // 老师名字
        beginTime: '', // 开课时间
        endTime: '', // 结束时间
        year: '', // 年份
        semester: '', // 学期
        classCycleStr: '', // 周期
        period: '', // 期次
        timeIntervalStr: '' // 时段
      })
    }
  },
  setup(props, { emit }) {
    console.log('store', store.state)
    /**
     * @description 编辑按钮点击事件
     */
    const editBtnClickHandler = () => {
      emit('editClick', props.itemData)
    }
    // 周期
    const periodName = id => computed(() => {
      const { periodList } = store.state.common
      const period = periodList.filter(item => item.id === id)
      return period && period[0] ? period[0].name : ''
    })
    return {
      editBtnClickHandler,
      periodName
    }
  },
  methods: {
    /**
     * 隐藏小组
     */
    handleHideGroup () {
      this.$confirm({
        title: '您确定隐藏该小组吗？',
        content: '确定后，该小组的相关信息将不在教师端中展示(不会影响学生端展示), 您可以在"【小组与学员】-->【隐藏小组列表】”中将小组恢复展示',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          // 接口对接
          this.$service.groupManage.hideGroup({ groupId: this.itemData.id, status: 1 }).then(res => {
            this.$message.success('操作成功')
            this.$emit('hideClick')
          })
        }
      })
    }
  },
  render() {
    const { year, semester, studentNum, teacherName, beginTime, endTime, period, classCycleStr, timeIntervalStr } = this.itemData
    const beginTimeStr = beginTime && beginTime.indexOf('1970') < 0 ? dateFormat(new Date(beginTime), 'yyyy年MM月dd日') : ''
    const endTimeStr = endTime && endTime.indexOf('1970') < 0 ? dateFormat(new Date(endTime), 'yyyy年MM月dd日') : ''
    return <div class="group-item">
      <div class="base-info">
        <div class="text">
          <span class="name">{this.itemData.groupName}</span>
          <span class="num">{studentNum + '人'}</span>
          <span class="teacher">{teacherName}</span>
        </div>
        <a-button type="t-link" onclick={this.editBtnClickHandler}>编辑</a-button>
        <a-button type="t-link" style="color: #FF8800;margin-left: 16px;" onclick={this.handleHideGroup}>隐藏</a-button>
      </div>
      <div class="date">
        { beginTimeStr || endTimeStr ? `${beginTimeStr} - ${endTimeStr}` : ''}
      </div>
      <div class="extra-info">
        <span class="year item">{`${year > 0 && semester ? year + ' ' + semester : ''}${semester > 0 ? semester : ''} `}</span>
        <span class="period item">{unref(this.periodName(period))}</span>
        <span class="class-cycle item">{classCycleStr}</span>
        <span class="time-interval item">{timeIntervalStr}</span>
      </div>
    </div>
  }
})
</script>
<style lang="less" scoped>
.group-item {
  padding: 12px 0;
  border-bottom: 1px solid #ddd;
  .base-info {
    display: flex;
    .text {
      flex: 1;
      .name {
        margin-right: 12px;
        font-size: 18px;
      }
      .num {
        margin-right: 12px;
      }
    }
  }
  .date {
    padding-bottom: 4px;
  }
  .extra-info {
    .item {
      padding-right: 12px;
    }
  }
}
</style>
